import gql from 'graphql-tag';
export default gql`
  query BuildLogById($id: Int!) {
    buildLogById(id: $id) {
      id
      machine
      env
      log
      seo
      timestamp
    }
  }
`;
